import { AbstractApiService } from "../abstractions/AbstractApiService";
import { OnRequestSuccess, OnRequestError } from "./Responses";

export class FavoriteService extends AbstractApiService {
    constructor() {
        super();
    }
    
    public FavoriteList(onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/favorite/myfavoritelist',
            onSuccess, onError);
    }
    
    public AddToFavorite(physiotherapistId: string, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/favorite/addtofavorite?physiotherapistId=' + physiotherapistId.toString(),
            onSuccess, onError);
    }
    
    public RemoveFavorite(physiotherapistId: string, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/favorite/removefavorite?physiotherapistId=' + physiotherapistId.toString(),
            onSuccess, onError);
    }
}


// WEBPACK FOOTER //
// ./src/services/FavoriteService.tsx